import React from 'react';
import { setTempState, useTempState } from '@starflow/app/store';
import helpers from '@starflow/app/helpers';
import { getSharedStage } from '../canvas/stage';

const handleContextMenu = (event) => {
  event.preventDefault();
};

const ContextMenuInner = ({ data, target, position }) => {
  const menu = helpers.component.getContextMenu()[target];

  const handleMeunClick = (menu) => {
    const stage = getSharedStage();
    const canvasPosition = stage.getPointerPosition();

    const absPosition = {
      x: (canvasPosition.x - stage.x()) / stage.scaleX(),
      y: (canvasPosition.y - stage.y()) / stage.scaleY(),
    };

    const keepMenu = menu.handler?.({ menu, data, absPosition, position });

    if (!keepMenu) {
      setTempState({
        contextMenuData: null,
        contextMenuTarget: null,
        contextMenuPosition: null,
      });
    }
  };

  return (
    <div style={position} onContextMenu={handleContextMenu} className="absolute z-[999] w-48 p-1 bg-[#2d2d2d] rounded">
      {menu.map((item) => {
        if (!item) return null;
        if (item.visible === false) return null;

        if (typeof item.visible === 'function' && !item.visible({ data, menu: item })) {
          return null;
        }

        return (
          <button
            key={item.name}
            data-name={item.name}
            onClick={() => handleMeunClick(item)}
            className="flex items-center w-full h-6 px-2 rounded-sm hover:bg-primary text-left"
          >
            <span className="flex-1 text-[11px] text-white leading-[1] font-normal">
              {typeof item.label === 'function' ? item.label(data) : item.label}
            </span>
            <span className="text-[10px] leading-[1] text-white/60">{item.hotkey}</span>
          </button>
        );
      })}
    </div>
  );
};

export const ContextMenu = React.memo(() => {
  const contextMenuData = useTempState('contextMenuData');
  const contextMenuTarget = useTempState('contextMenuTarget');
  const contextMenuPosition = useTempState('contextMenuPosition');

  if (!contextMenuTarget || !contextMenuPosition) {
    return null;
  }

  return <ContextMenuInner target={contextMenuTarget} data={contextMenuData} position={contextMenuPosition} />;
});
